import { render, staticRenderFns } from "./Admission.vue?vue&type=template&id=79ab9d8c&scoped=true&"
import script from "./Admission.vue?vue&type=script&lang=js&"
export * from "./Admission.vue?vue&type=script&lang=js&"
import style0 from "./Admission.vue?vue&type=style&index=0&id=79ab9d8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ab9d8c",
  null
  
)

export default component.exports